import {withStyles} from "@material-ui/styles";
import {InputBase} from "@material-ui/core";

export const LocationDropdown = withStyles((theme) => ({
    input: {
        textAlign: "center",
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4,
        position: 'relative',
        border: '1px solid #bdbdbd',
        padding: '4px 7px',

        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderTopRightRadius: 4,
            borderBottomRightRadius: 4,
        },
    },
}))(InputBase);

export const CustomInputNumber = withStyles((theme) => ({
    input: {
        textAlign: "center",
        borderTopLeftRadius: 4,
        borderBottomLeftRadius: 4,
        position: 'relative',
        border: '1px solid #bdbdbd',
        padding: '4px 7px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderTopLeftRadius: 4,
            borderBottomLeftRadius: 4,
        },
    },
}))(InputBase);